import useLoginCheck from 'hooks/common/useLoginCheck';
import { getNotificationList } from 'lib/api/notification';
import { changeProp } from 'modules/notificationSlice';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

const useNotificationTable = () => {
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);

  const { isLoading, isFetching, error, data, refetch } = useQuery(
    ['notificationList', currentPage],
    () => getNotificationList({ page: currentPage }),
    {
      keepPreviousData: true,
      onError: error => {
        if (error?.response.status === 500) {
          dispatch(changeProp({ key: 'error', value: true }));
        }
        dispatch(changeProp({ key: 'loading', value: false }));
      },
      onSuccess: () => {
        dispatch(changeProp({ key: 'loading', value: false }));
      },
    },
  );
  useLoginCheck(error?.response, refetch);
  const count = data?.data.list.count;
  const notificationList = data?.data.list.rows;

  useEffect(() => {
    if (
      isLoading ||
      isFetching ||
      error?.response.status === 401 ||
      error?.response.data.error === 'AuthorizationNotFound'
    ) {
      dispatch(changeProp({ key: 'loading', value: true }));
    }
  }, [
    dispatch,
    isLoading,
    isFetching,
    error?.response.status,
    error?.response.data.error,
  ]);

  return { currentPage, setCurrentPage, count, notificationList };
};

export default useNotificationTable;
